import { css } from "styled-components";

import { colorCSS } from "./colors";
import { redundantCssFromKebab } from "./redundant-css";
import { fontSizes } from "./textSize";

// to style UiMarkdown and UiTextBlock consistently
export function getOrderedListCSS(appearance?: string): ReturnType<typeof css> {
    if (!appearance) {
        return css`
            ol,
            ul {
                ${redundantCssFromKebab("text-align", "left")}
                p {
                    ${redundantCssFromKebab("margin", "0")}
                }
            }
        `;
    }

    const beforeContent =
        appearance === "UpperAlpha"
            ? "content: counter(ol-counter, upper-alpha);"
            : "content: '0' counter(ol-counter);";

    const nthChildStyle =
        appearance === "Number"
            ? "li:nth-child(n + 10)::before { content: counter(ol-counter); }"
            : "";

    return css`
        ol {
            ${redundantCssFromKebab("counter-reset", "ol-counter")}
            ${redundantCssFromKebab("list-style", "none")}
            ${redundantCssFromKebab("padding-inline-start", "0")}
            li {
                ${redundantCssFromKebab("counter-increment", "ol-counter")}
                ${redundantCssFromKebab("font-size", `${fontSizes.lg}`)}
                ${redundantCssFromKebab("margin-block-end", "2rem")}
                ${redundantCssFromKebab("padding-inline-start", "5rem")}
                @media (max-width: 576px) {
                    ${redundantCssFromKebab("padding-inline-start", "4rem")}
                }
                strong {
                    ${redundantCssFromKebab("display", "block")}
                }
                p {
                    ${redundantCssFromKebab("margin-block-end", "0")}
                    ${redundantCssFromKebab("display", "inline")}
                }
                &::before {
                    ${redundantCssFromKebab("display", "block")}
                    ${redundantCssFromKebab("position", "absolute")}
                    ${redundantCssFromKebab("margin-inline-start", "-5rem")}
                    ${redundantCssFromKebab("color", `${colorCSS("T400")}`)}
                    ${beforeContent}
                    ${redundantCssFromKebab("font-weight", "500")}
                    ${redundantCssFromKebab("font-size", "2.5rem")}
                    ${redundantCssFromKebab("margin-block-start", "-0.5rem")}
                    @media (max-width: 576px) {
                        ${redundantCssFromKebab("font-size", `${fontSizes.xl}`)}
                        ${redundantCssFromKebab("margin-inline-start", "-4rem")}
                        ${redundantCssFromKebab(
                            "margin-block-start",
                            "-0.25rem"
                        )}
                    }
                }
            }
            ${nthChildStyle}
        }
    `;
}
